export const LOCALES = ["pt-BR", "en", "de", "es"];

const defaultLocale = "en";

export function getCurrentLocale(pathname = window.location.pathname) {
  const firstSegment = pathname.split("/").filter(Boolean)[0];

  if (LOCALES.includes(firstSegment)) {
    return firstSegment;
  }

  return defaultLocale;
}

export function getLocalePath(locale) {
  return locale === defaultLocale ? "/" : `/${locale}`;
}

export const translations = {
  "pt-BR": {
    languageLabel: "Português",
    menu: {
      about: "Sobre",
      news: "Notícias",
      tour: "Tour",
      albums: "Álbuns",
      media: "Mídia",
      follow: "Siga",
    },
    hero: {
      quote: "Sem placas de pare, sem limite de velocidade, ninguém vai nos desacelerar. ...",
    },
    common: {
      viewMore: "Ver mais",
    },
    sections: {
      tour: {
        title: (
          <div>
            D<span>ATAS</span> DA TOUR
          </div>
        ),
        subtitle: "Na estrada",
      },
      about: {
        title: (
          <div>
            Sobre <span>The Instantors</span>
          </div>
        ),
        subtitle: "A história",
        description:
          "Vídeos, músicas e novidades oficiais da banda. Acompanhe The Instantors em todos os canais.",
        paragraphs: [
          "The Instantors é uma banda irlandesa que carrega a energia do rock clássico para palcos contemporâneos por toda a Europa.",
          "Com riffs diretos, presença de palco intensa e refrões feitos para cantar junto, o grupo constrói shows que soam próximos, vivos e sem artifícios.",
          "Entre festivais, casas independentes e novas gravações, a banda segue ampliando sua história com um som honesto, urgente e feito para a estrada.",
        ],
      },
      media: {
        title: (
          <div>
            Multi<span>Midia</span>
          </div>
        ),
        description:
          "Assista aos vídeos, registros ao vivo e conteúdos oficiais mais recentes da banda.",
      },
      albums: {
        title: (
          <div>
            Album<span>s</span>
          </div>
        ),
        description:
          "Conheça os lançamentos, singles e registros que marcam a trajetória de The Instantors.",
      },
      follow: {
        title: (
          <div>
            Siga <span>The Instantors</span>
          </div>
        ),
        description:
          "Acompanhe os bastidores, novidades e publicações oficiais da banda.",
        posts: "Posts",
        followers: "Seguidores",
        button: "Siga",
      },
      news: {
        title: (
          <div>
            Ultimas N<span>oticia</span>s
          </div>
        ),
        description:
          "Novidades, anúncios de shows e histórias recentes de The Instantors.",
        category: "Post",
        date: "21 maio 2021",
      },
    },
    events: [
      {
        title: "Brightlight Music Festival",
        subtitle: "Rock Indie",
        value: "€40 - €90",
        month: "SET",
        day: "12",
        weekday: "QUI",
      },
    ],
    albums: [
      { name: "Royal Blood", artist: "The Instantors", year: "2018" },
      { name: "Vertical", artist: "The Instantors", year: "2018" },
      { name: "Led Zeppelin", artist: "The Instantors", year: "2018" },
      { name: "One of the Devil", artist: "The Instantors", year: "2018" },
      { name: "The Jam", artist: "The Instantors", year: "2018" },
      { name: "Dark & Blues", artist: "The Instantors", year: "2018" },
    ],
    news: [
      {
        title: "One of the Devil",
        description:
          "Uma nova fase da banda ganha força entre ensaios, estrada e o pulso direto do rock irlandês...",
      },
      {
        title: "Noites na estrada",
        description:
          "A agenda europeia aproxima The Instantors de públicos novos em festivais e palcos independentes...",
      },
      {
        title: "Som ao vivo",
        description:
          "Os registros recentes mostram uma banda mais crua, intensa e pronta para transformar cada show em celebração...",
      },
      {
        title: "Novas sessões",
        description:
          "A banda prepara novas gravações e experimenta arranjos sem perder a energia que move seus shows...",
      },
    ],
    footer: {
      copy: "© 2025 The Instantors. Política de Privacidade. Termos de Uso.",
      poweredBy: "Desenvolvido por",
    },
  },
  en: {
    languageLabel: "English",
    menu: {
      about: "About",
      news: "News",
      tour: "Tour",
      albums: "Albums",
      media: "Media",
      follow: "Follow",
    },
    hero: {
      quote: "No stop signs, speed limit, nobody's gonna slow me down. ...",
    },
    common: {
      viewMore: "View More",
    },
    sections: {
      tour: {
        title: (
          <div>
            T<span>OUR</span> DATES
          </div>
        ),
        subtitle: "On The Road",
      },
      about: {
        title: (
          <div>
            About <span>The Instantors</span>
          </div>
        ),
        subtitle: "The History",
        description:
          "Official videos, songs and updates from the band. Follow The Instantors across every channel.",
        paragraphs: [
          "The Instantors are an Irish band bringing the pulse of classic rock into modern stages across Europe.",
          "With direct riffs, a fierce live presence and choruses built to be sung back, the group turns each show into something immediate and alive.",
          "From festivals to independent venues and new studio sessions, the band keeps expanding its story with honest, road-built rock.",
        ],
      },
      media: {
        title: (
          <div>
            Multi<span>Media</span>
          </div>
        ),
        description:
          "Watch the latest videos, live moments and official visual releases from the band.",
      },
      albums: {
        title: (
          <div>
            Album<span>s</span>
          </div>
        ),
        description:
          "Explore the releases, singles and records that shape The Instantors' sound.",
      },
      follow: {
        title: (
          <div>
            Follow <span>The Instantors</span>
          </div>
        ),
        description:
          "Follow backstage moments, updates and official posts from the band.",
        posts: "Posts",
        followers: "Followers",
        button: "Follow",
      },
      news: {
        title: (
          <div>
            Latest N<span>ew</span>s
          </div>
        ),
        description:
          "News, show announcements and recent stories from The Instantors.",
        category: "Post",
        date: "May 21, 2021",
      },
    },
    events: [
      {
        title: "Brightlight Music Festival",
        subtitle: "Indie Rock",
        value: "€40 - €90",
        month: "SEP",
        day: "12",
        weekday: "THU",
      },
    ],
    albums: [
      { name: "Royal Blood", artist: "The Instantors", year: "2018" },
      { name: "Vertical", artist: "The Instantors", year: "2018" },
      { name: "Led Zeppelin", artist: "The Instantors", year: "2018" },
      { name: "One of the Devil", artist: "The Instantors", year: "2018" },
      { name: "The Jam", artist: "The Instantors", year: "2018" },
      { name: "Dark & Blues", artist: "The Instantors", year: "2018" },
    ],
    news: [
      {
        title: "One of the Devil",
        description:
          "A new chapter for the band gathers force between rehearsals, the road and the direct pulse of Irish rock...",
      },
      {
        title: "Nights on the road",
        description:
          "The European calendar brings The Instantors closer to new audiences at festivals and independent stages...",
      },
      {
        title: "Live sound",
        description:
          "Recent footage shows a rawer, stronger band ready to turn every show into a celebration...",
      },
      {
        title: "New sessions",
        description:
          "The band is shaping new recordings and arrangements without losing the energy that drives its shows...",
      },
    ],
    footer: {
      copy: "© 2025 The Instantors. Privacy Policy. Terms of Use.",
      poweredBy: "Powered by",
    },
  },
  de: {
    languageLabel: "Deutsch",
    menu: {
      about: "Über uns",
      news: "News",
      tour: "Tour",
      albums: "Alben",
      media: "Medien",
      follow: "Folgen",
    },
    hero: {
      quote: "Keine Stoppschilder, kein Tempolimit, niemand bremst uns aus. ...",
    },
    common: {
      viewMore: "Mehr ansehen",
    },
    sections: {
      tour: {
        title: (
          <div>
            T<span>OUR</span>DATEN
          </div>
        ),
        subtitle: "Unterwegs",
      },
      about: {
        title: (
          <div>
            Uber <span>The Instantors</span>
          </div>
        ),
        subtitle: "Die Geschichte",
        description:
          "Offizielle Videos, Songs und Neuigkeiten der Band. Folge The Instantors auf allen Kanälen.",
        paragraphs: [
          "The Instantors sind eine irische Band, die die Energie des klassischen Rock auf moderne Bühnen in ganz Europa bringt.",
          "Mit direkten Riffs, starker Live-Präsenz und Refrains zum Mitsingen macht die Band jedes Konzert unmittelbar und lebendig.",
          "Zwischen Festivals, unabhängigen Clubs und neuen Studio-Sessions schreibt die Band ihre Geschichte mit ehrlichem Rock für die Straße weiter.",
        ],
      },
      media: {
        title: (
          <div>
            Multi<span>Media</span>
          </div>
        ),
        description:
          "Sieh dir die neuesten Videos, Live-Momente und offiziellen visuellen Veröffentlichungen der Band an.",
      },
      albums: {
        title: (
          <div>
            Albe<span>n</span>
          </div>
        ),
        description:
          "Entdecke die Releases, Singles und Aufnahmen, die den Sound von The Instantors prägen.",
      },
      follow: {
        title: (
          <div>
            Folge <span>The Instantors</span>
          </div>
        ),
        description:
          "Folge Backstage-Momenten, Updates und offiziellen Posts der Band.",
        posts: "Posts",
        followers: "Follower",
        button: "Folge",
      },
      news: {
        title: (
          <div>
            Neueste N<span>ew</span>s
          </div>
        ),
        description:
          "Neuigkeiten, Konzertankündigungen und aktuelle Geschichten von The Instantors.",
        category: "Post",
        date: "21. Mai 2021",
      },
    },
    events: [
      {
        title: "Brightlight Music Festival",
        subtitle: "Indie Rock",
        value: "€40 - €90",
        month: "SEP",
        day: "12",
        weekday: "DO",
      },
    ],
    albums: [
      { name: "Royal Blood", artist: "The Instantors", year: "2018" },
      { name: "Vertical", artist: "The Instantors", year: "2018" },
      { name: "Led Zeppelin", artist: "The Instantors", year: "2018" },
      { name: "One of the Devil", artist: "The Instantors", year: "2018" },
      { name: "The Jam", artist: "The Instantors", year: "2018" },
      { name: "Dark & Blues", artist: "The Instantors", year: "2018" },
    ],
    news: [
      {
        title: "One of the Devil",
        description:
          "Ein neues Kapitel der Band gewinnt zwischen Proben, Tour und dem direkten Puls des irischen Rock an Kraft...",
      },
      {
        title: "Nächte unterwegs",
        description:
          "Der europäische Kalender bringt The Instantors auf Festivals und unabhängigen Bühnen näher an neues Publikum...",
      },
      {
        title: "Live-Sound",
        description:
          "Neue Aufnahmen zeigen eine rauere, stärkere Band, bereit jedes Konzert in eine Feier zu verwandeln...",
      },
      {
        title: "Neue Sessions",
        description:
          "Die Band arbeitet an neuen Aufnahmen und Arrangements, ohne die Energie ihrer Shows zu verlieren...",
      },
    ],
    footer: {
      copy: "© 2025 The Instantors. Datenschutz. Nutzungsbedingungen.",
      poweredBy: "Umgesetzt von",
    },
  },
  es: {
    languageLabel: "Español",
    menu: {
      about: "Sobre",
      news: "Noticias",
      tour: "Tour",
      albums: "Álbumes",
      media: "Media",
      follow: "Seguir",
    },
    hero: {
      quote: "Sin señales de alto, sin límite de velocidad, nadie nos va a frenar. ...",
    },
    common: {
      viewMore: "Ver más",
    },
    sections: {
      tour: {
        title: (
          <div>
            FECHAS DE <span>TOUR</span>
          </div>
        ),
        subtitle: "En la carretera",
      },
      about: {
        title: (
          <div>
            Sobre <span>The Instantors</span>
          </div>
        ),
        subtitle: "La historia",
        description:
          "Videos, canciones y novedades oficiales de la banda. Sigue a The Instantors en todos los canales.",
        paragraphs: [
          "The Instantors es una banda irlandesa que lleva la energía del rock clásico a escenarios modernos por toda Europa.",
          "Con riffs directos, una presencia en vivo intensa y coros hechos para cantar, el grupo convierte cada show en algo cercano y vivo.",
          "Entre festivales, salas independientes y nuevas sesiones de estudio, la banda sigue ampliando su historia con rock honesto de carretera.",
        ],
      },
      media: {
        title: (
          <div>
            Multi<span>Media</span>
          </div>
        ),
        description:
          "Mira los últimos videos, momentos en vivo y lanzamientos visuales oficiales de la banda.",
      },
      albums: {
        title: (
          <div>
            Album<span>es</span>
          </div>
        ),
        description:
          "Explora los lanzamientos, singles y discos que dan forma al sonido de The Instantors.",
      },
      follow: {
        title: (
          <div>
            Sigue a <span>The Instantors</span>
          </div>
        ),
        description:
          "Sigue momentos de backstage, novedades y publicaciones oficiales de la banda.",
        posts: "Posts",
        followers: "Seguidores",
        button: "Seguir",
      },
      news: {
        title: (
          <div>
            Ultimas N<span>oticia</span>s
          </div>
        ),
        description:
          "Noticias, anuncios de conciertos e historias recientes de The Instantors.",
        category: "Post",
        date: "21 mayo 2021",
      },
    },
    events: [
      {
        title: "Brightlight Music Festival",
        subtitle: "Rock Indie",
        value: "€40 - €90",
        month: "SEP",
        day: "12",
        weekday: "JUE",
      },
    ],
    albums: [
      { name: "Royal Blood", artist: "The Instantors", year: "2018" },
      { name: "Vertical", artist: "The Instantors", year: "2018" },
      { name: "Led Zeppelin", artist: "The Instantors", year: "2018" },
      { name: "One of the Devil", artist: "The Instantors", year: "2018" },
      { name: "The Jam", artist: "The Instantors", year: "2018" },
      { name: "Dark & Blues", artist: "The Instantors", year: "2018" },
    ],
    news: [
      {
        title: "One of the Devil",
        description:
          "Una nueva etapa de la banda toma fuerza entre ensayos, carretera y el pulso directo del rock irlandés...",
      },
      {
        title: "Noches en la carretera",
        description:
          "El calendario europeo acerca a The Instantors a nuevos públicos en festivales y escenarios independientes...",
      },
      {
        title: "Sonido en vivo",
        description:
          "Los registros recientes muestran una banda más cruda, intensa y lista para convertir cada show en celebración...",
      },
      {
        title: "Nuevas sesiones",
        description:
          "La banda prepara nuevas grabaciones y arreglos sin perder la energía que mueve sus conciertos...",
      },
    ],
    footer: {
      copy: "© 2025 The Instantors. Política de Privacidad. Términos de Uso.",
      poweredBy: "Desarrollado por",
    },
  },
};

export function getTranslations(locale) {
  return translations[locale] || translations[defaultLocale];
}
